import Script from 'next/script'
import type { ComponentProps } from 'react'
import { isDevelopment } from '@/lib/general-helpers.ts'

export const ThirdPartyScriptWrapper = ({
	id,
	scriptContent,
	scriptOptions,
	ignoreInDevelopment = true,
}: {
	scriptContent: string
	id: string
	scriptOptions: Exclude<ComponentProps<typeof Script>, 'id' | 'dangerouslySetInnerHTML'>
	ignoreInDevelopment?: boolean
}) => {
	if (ignoreInDevelopment && isDevelopment()) {
		return null
	}
	// biome-ignore lint/security/noDangerouslySetInnerHtml: Your Grace, I did what had to be done. Content should be hardcoded, no security implications here.
	return <Script id={id} dangerouslySetInnerHTML={{ __html: scriptContent }} {...scriptOptions} />
}
